import styled from 'styled-components';

import colors from '../../../../../styles/colors';
import { Title } from '../../../../../components/v2/Header';

const Container = styled.div`
  width: 35%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

const StyledTitle = styled(Title)`
  color: ${colors.shades.beta2};
  font-weight: 500;
  margin-bottom: 0;
`;

export {
  Container,
  RowContainer,
  StyledTitle,
};
